module.exports = __webpack_public_path__ + "img/Avatar-39.ec9c0fe4.svg";